import { c as _c } from "react/compiler-runtime";
import { CenteredPageContent } from '@/components/Layouts/CenteredPageContent';
import { ProseColumn } from '@/components/Molecules/ProseColumn/ProseColumn';
import classNames from '@/utils/classNames';
import type { FCC } from 'react-fc';
import styles from './ArticlePageTemplate.module.css';
export const ArticlePageTemplate: FCC = t0 => {
  const $ = _c(7);
  const {
    children,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = classNames("cds-grid", styles.articlePage, className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== children) {
    t2 = <div className={styles.grid}>{children}</div>;
    $[2] = children;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <CenteredPageContent featured={true} className={t1}>{t2}</CenteredPageContent>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};
export const ArticlePageMain: FCC = t0 => {
  const $ = _c(7);
  const {
    children,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = classNames(styles.main, className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== children) {
    t2 = <ProseColumn>{children}</ProseColumn>;
    $[2] = children;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <div className={t1}>{t2}</div>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};
export const ArticlePageAside: FCC<{
  position?: 'before' | 'after';
}> = ({
  children,
  className,
  position
}) => {
  return <aside className={classNames(styles.aside, className, 'cds-vstack', {
    [`cds-grid__sidebar--${position}`]: position
  })}>
            {children}
        </aside>;
};